var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import BaseModel from './BaseModel';
import { UpsellRuleModel } from './UpsellRuleModel';
import { find, filter, isEmpty } from 'lodash';
var UpsellModel = /** @class */ (function (_super) {
    __extends(UpsellModel, _super);
    function UpsellModel(data) {
        var _this = _super.call(this, data) || this;
        _this.mobileEnabled = _this.convertBool(data.mobile_enabled);
        _this.posEnabled = _this.convertBool(data.pos_enabled);
        _this.rules = [
            new UpsellRuleModel(data.rules[0]),
        ];
        _this.type = data.type;
        _this.id = data.upsell_id;
        return _this;
    }
    UpsellModel.prototype.itemRule = function (itemIds) {
        var rule = this.rules[0];
        if (rule.hasItem(itemIds)) {
            return rule;
        }
        return null;
    };
    UpsellModel.prototype.getOptionFromRuleSet = function (options) {
        var rule = this.rules[0];
        return this.getOptionForRule(options, rule);
    };
    UpsellModel.prototype.getOptionForRule = function (options, rule) {
        var option = find(options, function (option) {
            var matchId = option.id.replace(/f/, '');
            var ruleId = rule.optionId.replace(/f/, '');
            return (matchId === ruleId);
        });
        return option;
    };
    UpsellModel.prototype.ruleApplicable = function (options) {
        if (!this.mobileEnabled) {
            return false;
        }
        var rule = this.rules[0];
        var option = this.getOptionForRule(options, rule);
        var choices = filter(option.choices, function (choice) {
            return (choice.id === rule.choiceId);
        });
        if (isEmpty(choices)) {
            return false;
        }
        return true;
    };
    UpsellModel.prototype.getUpgradeChoice = function (choices, rule) {
        var upgradeChoice = find(choices, function (choice) {
            return (choice.id === rule.targetChoiceId);
        });
        return upgradeChoice;
    };
    UpsellModel.prototype.getDiscountAmount = function (itemIds) {
        var rule = this.itemRule(itemIds);
        var amount = rule.getItemTargetDiscount(itemIds);
        return amount;
    };
    return UpsellModel;
}(BaseModel));
export default UpsellModel;



//////////////////
// WEBPACK FOOTER
// ./src/models/UpsellModel.ts
// module id = null
// module chunks = 